import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { GenericOrderDetailGateway } from 'src/app/application/gateway/GenericOrderDetailGateway';
import { ImportOrderDetailGateway } from 'src/app/application/gateway/ImportOrderDetailGateway';
import { QualityControlReviewGateway } from 'src/app/application/gateway/QualityControlReviewGateway';
import { GenericOrderDetail, ImportOrderDetail } from 'src/app/domain/models/ImportOrder';
import { QualityControlReviewItemList } from 'src/app/domain/models/QualityControlReview';
import { Species } from 'src/app/domain/models/Species';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';
import { SpeciesUtils } from 'src/app/ui/util/species-utils';

@Component({
  selector: 'app-qc-user-reviews',
  templateUrl: './qc-user-reviews.component.html',
  styleUrls: ['./qc-user-reviews.component.css'],

})
export class QcUserReviewsComponent implements OnInit {

  tabMenuItems: MenuItem[] = []
  activeItem: MenuItem = {}

  loading: boolean = false

  profile: BasicUser | undefined
  reviews: GenericOrderDetail[] = []
  reviews2: QualityControlReviewItemList[] = []

  programOrderOption: string = "Program"
  marketplaceOrderOption: string = "Marketplace"

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _authService: AuthGateway,
    public translate: TranslateService,
    private _importOrderDetailService: ImportOrderDetailGateway,
    private _genericOrderDetailSercice: GenericOrderDetailGateway,
    private _qualityControlReviewService: QualityControlReviewGateway) {

  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()
    //this.loadOriginReviews()
    //this.tabMenuItems = [
    //  { label: 'Pending', command: () =>  this._router.navigate(['/'+Routes.qcUserReviews]) },
    //  { label: 'Reviewed', command: () =>  this._router.navigate(['/'+Routes.qcUserOriginReviewed]) }
    //]
    //this.activeItem = this.tabMenuItems[0]

    this.loadOriginReviews2()
  }

  ngAfterViewInit(){
    const lang = this.translate.currentLang
    switch(lang) {
      case 'es':
        this.tabMenuItems = [
          { label: 'Pendientes', command: () =>  this._router.navigate(['/'+Routes.qcUserReviews]) },
          { label: 'Revisadas', command: () =>  this._router.navigate(['/'+Routes.qcUserOriginReviewed]) }
        ]
        break
      case 'en':
        this.tabMenuItems = [
          { label: 'Pending', command: () =>  this._router.navigate(['/'+Routes.qcUserReviews]) },
          { label: 'Reviewed', command: () =>  this._router.navigate(['/'+Routes.qcUserOriginReviewed]) }
        ]
        break
    }

    this.activeItem = this.tabMenuItems[0]

  }

  loadOriginReviews() {
    if(this.profile) {
      this.loading = true
      this.reviews = []
      this._genericOrderDetailSercice.getAllPendingForQCReviews().subscribe({
        next: (v) => {
          console.log(v)
          this.reviews = v
          this.loading = false
          const lang = this.translate.currentLang
          switch(lang) {
            case 'es':
              this.programOrderOption = "Programa"
              break
            case 'en':
              this.programOrderOption = "Program"
              break
          }
        },
        error: (e) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'Could not retrieve the import order details' });

          this.loading = false
          console.log(e)
        },
        complete: () =>  {
          this.loading = false
          console.info('Reviews query successfully')
        }
      })
    }
  }

  goToReviewDocuments(review: QualityControlReviewItemList) {
    this._router.navigate(['/'+Routes.qcUserReviewDocuments, review.guid])
  }

  loadOriginReviews2() {
    this._qualityControlReviewService.getAllByStatusAndReviewType(1, 1).subscribe({
      next: (v) => {
        this.reviews2 = v
        this.loading = false
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: 'Could not retrieve the import order details' });

        this.loading = false
        console.log(e)
      },
      complete: () =>  {
        this.loading = false
        console.info('Reviews query successfully')
      }
    })
  }

  goToOriginReview(review: QualityControlReviewItemList) {
    if(!review.isFrozenFruit)
      this._router.navigate(['/'+Routes.qcUserOriginReview, review.guid])
    else
      this._router.navigate(['/'+Routes.qcUserFrozenFruitOriginReviewPage, review.guid])
  }

    getIconUrl(iconUrl: string | undefined): string {
      return iconUrl ? iconUrl : ''
    }

    setVisibleOrderDetail(order: any) {
      if (order) {
        order.expanded = !order.expanded
      }
    }
}
